<template>
    <ob1-search-field
        id="search-field"
        v-model="value"
        :label="placeHolder"
        :show-auto-completion="showAutoCompletion"
        @input="inputSearchFiledHandler"
    />
</template>

<script>
import {algoliasearch} from "algoliasearch";

export default {
    props: {
        placeHolder: {
            type: String,
            default: ""
        },
        searchResultsUrl: {
            type: String,
            required: true
        },
        searchResultsQueryAdditionalParams: {
            type: String,
            required: true
        },
        algoliaAppId: {
            type: String,
            required: true
        },
        algoliaApiKey: {
            type: String,
            required: true
        },
        algoliaIndexName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            value: "",
            responseList: [""], // astuce pour ne pas afficher d'erreur avant la saisie de 3 caractères
            showAutoCompletion: false
        }
    },
    mounted: function () {
        this.searchFieldHandler();
    },
    methods: {
        searchFieldHandler() {
            const searchFieldButton = document.getElementById('search-field-button')
            const searchField = document.getElementById('search-field')
            searchFieldButton.addEventListener('click', () => {
                document.location.href = this.searchResultsUrl + '/?kw=' + searchField.value + this.searchResultsQueryAdditionalParams + this.defineAccessorySearchParams()
            });
        },
        defineAccessorySearchParams() {
            return (new URL(window.location.href)).pathname.includes('accessoires') ? '&category=accessories' : ''
        },
        inputSearchFiledHandler(value) {
            const elt = document.querySelector("#search-field");
            if (!elt) {
                return;
            }
            const searchField = ob1.Ob1Component.get(elt).SearchField;
            if (!searchField) {
                return;
            }
            searchField.repository = this.responseList;
            this.showAutoCompletion = false
            if (value.length >= 3) {
                const client = algoliasearch(this.algoliaAppId, this.algoliaApiKey);
                const indexName = this.algoliaIndexName;
                client.search({
                    requests: [
                        {
                            indexName: indexName,
                            query: value,
                            hitsPerPage: 5
                        },
                    ],
                }).then((results) => {
                        if (results.results && results.results.length > 0) {
                            this.responseList = results.results[0].hits.map(hit => hit.query);
                            if (this.responseList.length === 0) {
                                this.responseList = [""]; // astuce pour ne pas afficher d'erreur en cas de liste vide
                            }
                            searchField.repository = this.responseList;
                            elt.dispatchEvent(new Event("keyup")); // on force la resynchronisation avec le js ob1
                            if (this.responseList.length === 1) {
                                this.showAutoCompletion = this.responseList[0].length !== 0;
                            } else {
                                this.showAutoCompletion = this.responseList.length !== 0;
                            }
                        }
                    }
                ).catch(() => {
                    this.responseList = [""];
                })
            }
        }
    }
}
</script>
